const bxfLoading = {
    svg: '<svg style="flex-shrink: 0;forced-color-adjust: auto;fill: currentcolor; width:3.50rem; height:2.00rem;" viewBox="0 0 56 32"><g>        <circle class="outter-circle" cx="16" cy="16" r="16" fill="#FFCE00" />        <circle class="circle-1" cx="9" cy="20" r="2" fill="black" />        <circle class="circle-2" cx="16" cy="20" r="2" fill="black" />        <circle class="circle-3" cx="23" cy="20" r="2" fill="black" />    </g></svg>',
};

export { bxfLoading as default };
